import React from "react";
import PropTypes from "prop-types";
import { Field, Label, Radio, Message } from "@zendeskgarden/react-forms";
import styled from "styled-components";

import media from "../theme/rwd";

const Wrapper = styled('div')`
    margin-top: 3rem;
`;

const Container  = styled('div')`
  display: grid;
  grid-template-columns: 1fr;
  ${media.md`
      grid-template-columns: min-content auto;
       grid-column-gap: 2rem;
  `}
`;

const Caption = styled('span')`
  color: ${props => props.theme.palette.yellow[400]};
  font-size: 1.2rem;
`;

const ChartScaleField = ({ value, onChange }) => {
  const handleOnChange = (e) => onChange(e.target.name);
  return (
    <Wrapper>
      <Label>Select scale:</Label>
      <Container>
        <Field>
          <Radio name="linear" checked={value === 'linear'} onChange={handleOnChange}>
            <Label isRegular>
              Linear
            </Label>
          </Radio>
        </Field>
        <Field>
          <Radio name="log" checked={value === 'log'} onChange={handleOnChange}>
            <Label isRegular>
              Logarithmic
            </Label>
          </Radio>
        </Field>
      </Container>
    </Wrapper>
  );
};

ChartScaleField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ChartScaleField;
